module.exports = __webpack_public_path__ + "img/painting-app_en.ede048b.jpg";